import React, { useState } from 'react';

const OTPScreen = ({ mobileNumber, otp, setOtp, onLogin, sentOTPResMessage }) => {

    const handleChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value.slice(0, 1); // Limit to 1 character
        setOtp(newOtp);

        // Move focus to next input if value is entered
        if (value && index < 3) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
        // Move focus to previous input if backspace is pressed
        if (value === '' && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    return (
        <div>
            <p className='text-center text-gray-600 '>
                {sentOTPResMessage}
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                {otp.map((digit, index) => (
                    <input
                        key={index}
                        id={`otp-input-${index}`}
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                                onLogin();
                            }
                        }}
                        style={{
                            width: '50px',
                            height: '50px',
                            fontSize: '24px',
                            textAlign: 'center',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            outline: 'none',
                            backgroundColor: '#f9f9f9'
                        }}
                        autoFocus={index === 0} // Auto-focus first input
                    />
                ))}
            </div>
        </div>
    );
};

export default OTPScreen;